<!-- HEADING PART -->
<p-card>
    <div class="grid" >
    
      <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu" >
          <div class="text-end p-0 border-round-sm font-bold">
            <p-button pTooltip="Add Hub" tooltipPosition="left" (click)="show('Add Hub','')" styleClass="customAdd p-button-sm p-button-raised mr-4" icon="fa fa-plus p-button-icon ng-star-inserted"></p-button>
              <button class="fa fa-question helpicon" pTooltip="Help"
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','4')" tooltipPosition="bottom"
          aria-hidden="true"></button>
          </div>

      </div>
   
    </div>
  
    <div >
        <p-table #dt [value]="tableData" [customSort]="true" (sortFunction)="this.utilityservice.customSort($event)" 
        [columns]="_selectedColumns" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal"
        scrollHeight="{{commonScrollHeight}}"  [first]="currentPageIndex"
        [globalFilterFields]="['createdby','hubid','hubname','createdon','activeflag']"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
        paginatorLocale="fa-IR" [paginator]="totalRecords>10" [sortOrder]="1" responsiveLayout="scroll"
        sortField="hubname"
        (onPage)="handlePageChange($event)"
        [totalRecords]="totalRecords" [resizableColumns]="true" columnResizeMode="expand">
        <!-- search -->
        <ng-template pTemplate="caption">
          <div class="grid table-header">
            <div class="col-12 md:col-10 sm:col-12 lg:col-10">
              <span class=" p-input-icon-lft">
                <i icon="pi pi-search"></i>
                <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;" placeholder="Search in Hub"
                  class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
              </span>
            </div>
            <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
              <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom"
              (click)="showDialog()"></div>
            </div>
          </div>
      </ng-template>
  
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 5px !important;" class="tableaction">Action</th>
            <ng-container *ngFor="let col of _selectedColumns">
              <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked" >
                {{col.header}}<p-sortIcon [field]="col.field" ></p-sortIcon>
                <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
  
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr>
            <td  style="width: 5px !important;">
              <div style="display: flex; gap: 0px;">
                <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                    (click)="show('Modify Hub',data)"></i></span>
              </div>
            </td>
            <ng-container *ngFor="let col of _selectedColumns" >
              <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field !== 'activeflag'" pTooltip=" {{data[col.field]}}"
                [innerHTML]="highlight(data[col.field],searchTerm)"></span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag" aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag" aria-hidden="true" style="color: red;"></i>
                </span>
            </td>
            <!-- <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"  >
              <span *ngIf="col.field!=='activeflag'" pTooltip=" {{data[col.field] }}">{{data[col.field]}}</span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag" aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag" aria-hidden="true" style="color: red;"></i>
                </span>
            </td> -->
          </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="card" style="margin-top: -4px;" *ngIf="tableData.length==0">
      <p-card>
        <p style="text-align: center;">Data not found...</p>
      </p-card>
    </div>
  
  
  
  </p-card>
     
  
      
  
  
  